import { createHost } from '@dialpad/host-entry';
import { hostI18NManager } from './localization/i18n';
import { hostRouter } from './router';
import { hostEnv } from './constants';
import App from './App.vue';
import { hostPinia } from './host-pinia';
import { hostDirectives } from './directives';
import { hostAuthController, provideAuthController } from './auth';
import type { Auth } from './auth';
import { hostPowerDialerApis } from './apis';
import { hostPubSub } from './pub-sub';
import logger from '@/logger';
import { setTokenGetter } from '@dialpad/logger';
import { hostSentry } from '@dialpad/o11y/sentry-plugin';
import type { ErrorProvider } from '@dialpad/o11y/metrics';
import { connectLoggerToSentry } from './connect-logger-to-sentry';

logger.log(`
  ------------------------------
  PowerDialer Admin UI
  Version: ${hostEnv.APP_VERSION}
  ------------------------------
  `);

await createHost<{ auth: Auth; errorProvider: ErrorProvider }, typeof hostEnv>(
  hostEnv,
)
  .hostInit(hostAuthController)
  .hostInit(({ auth: { authController } }) => {
    setTokenGetter(() => authController.getToken());
    return { logger };
  })
  .withVue(App, '#app')
  .vueCreated(hostSentry)
  .vueCreated(connectLoggerToSentry)
  .vueCreated(hostPowerDialerApis)
  .vueCreated(hostI18NManager)
  .vueCreated(hostRouter)
  .vueCreated(hostPinia)
  .vueCreated(hostDirectives)
  .vueCreated(hostPubSub)
  .vueCreated(provideAuthController)
  .start();
